const STORAGE_KEY = "deu-unavailable-dataset-ids";

function normalizeDatasetId(datasetId) {
  if (typeof datasetId !== "string") return "";
  return datasetId.trim();
}

function readUnavailableDatasetIds() {
  if (typeof window === "undefined") return [];

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed
      .map((id) => normalizeDatasetId(String(id)))
      .filter((id) => id.length > 0);
  } catch {
    return [];
  }
}

function writeUnavailableDatasetIds(ids) {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Ignore storage write failures.
  }
}

export function addUnavailableDatasetId(datasetId) {
  const normalizedId = normalizeDatasetId(datasetId);
  if (!normalizedId) return;

  const currentIds = readUnavailableDatasetIds();
  if (currentIds.includes(normalizedId)) return;

  writeUnavailableDatasetIds([...currentIds, normalizedId]);
}

export function isUnavailableDatasetId(datasetId) {
  const normalizedId = normalizeDatasetId(datasetId);
  if (!normalizedId) return false;

  return readUnavailableDatasetIds().includes(normalizedId);
}
